<style lang="less" scoped>
.medicine-list {
  width: 100%;
  > li {
    display: flex;
    width: 100%;
    align-items: center;
    .medicine-name {
      flex: 1;
    }
  }
}
.search-form {
  display: flex;
  .search-input {
    flex: 1;
  }
  .search-button {
    padding-left: 10px;
    button {
      height: 100%;
    }
  }
}
.description {
  color: gray;
  padding-left: 5px;
  font-size: .9em;
}
</style>

<template lang="pug">
  div
    .search-cover.dialog-content-cover
      form.search-form(method="post" action="#" @submit.prevent="submit")
        div.search-input
          el-input(type="text" v-model="keyword" placeholder="검색")
        div.search-button
          el-button(type="success" native-type="submit") 검색
    .medicine-list-cover
      ul.medicine-list
        li.dialog-content-cover(
          v-for="prescription in prescriptions",
          @click="selectPrescription(prescription)")
          span.medicine-name {{prescription.name}}
            span.description {{prescription.source}}
          img(
            src="@/assets/chevron-left-small@2x.png",
            style="width: 16px")
</template>

<script>
export default {
  props: ['prescriptions'],
  data() {
    return {
      keyword: null,
    };
  },
  events: {
    close() {
      alert('모달 닫힘!');
    },
  },
  methods: {
    async selectPrescription(obj) {
      // 깊은 복사(?)
      const copyobj = JSON.parse(JSON.stringify(obj));
      this.$emit('selectPrescription', copyobj);
    },
    async resetModal() {
      this.keyword = null;
    },
    async submit() {
      // await this.resetModal();
      this.$emit('search', this.keyword);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal/modal_recipe_choose.vue